import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import './inline-warning.scss';
import styleable from 'react-styleable';
import defaultStyle from './common.style.js';

export class InlineWarning extends Component {
  render() {
    const { warn, css } = this.props;
    return warn ? (
      <div role="alert" aria-live="assertive" className={css.warningWrapper}>
        { warn }
      </div>
    ) : null;
  }
}

InlineWarning.propTypes = {
  warn: PropTypes.any
};

export default styleable(defaultStyle) (InlineWarning);



// WEBPACK FOOTER //
// src/common/inline-warning.js